import { Inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot, CanActivate, CanLoad,
    Route, Router, RouterStateSnapshot, UrlSegment
} from '@angular/router';
import { Observable } from 'rxjs';
import { WINDOW, WindowWrapper } from '../../common/services/window.service';

@Injectable({
    providedIn: 'root'
})
export class RedirectGuard implements CanActivate, CanLoad {

    constructor(
        @Inject(WINDOW) private window: WindowWrapper,
        private router: Router
    ) { }

    private _check(params: { url?: string, segments?: UrlSegment[] }): boolean {
        if (!this.router.navigated &&
            ((params.hasOwnProperty('url') && params.url.replace(/\//g, '') === '')
                || (params.hasOwnProperty('segments') && !params.segments.length))) {
            const pars: { state: string, state_params?: { [key: string]: number | boolean | string } } =
                JSON.parse(this.window.sessionStorage.getItem('appChangeParams'));
            if (pars && pars.state
                && !this.router.isActive(this.router.createUrlTree([pars.state], { queryParams: pars.state_params }), false)) {
                this.router.navigate([pars.state], { queryParams: pars.state_params });
            }
        }
        return true;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this._check({ url: state.url });
    }

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this._check({ segments });
    }

}
